export default __webpack_public_path__ + "static/media/beta_test.6a31042b.png";